import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { EVENTS_CONFIG } from '@app-core/constants/constants';
import { DataService } from '@app-core/services/data/data.service';
import {
  MOST_IMPROVED_TABLE_COLUMNS,
  REQUIRE_COACHING_TABLE_COLUMNS,
  TOP_DRIVERS_TABLE_COLUMNS,
} from '@app-reports/constants/reports.constants';

@Component({
  selector: 'app-report-driver-list',
  templateUrl: './report-driver-list.component.html',
  styleUrls: ['./report-driver-list.component.scss'],
})
export class ReportDriverListComponent implements OnInit, OnChanges {
  @Input()
  public driverList: any;
  @Input()
  public listType: string;
  @Input()
  public loader = false;

  public tableColumns: string[];
  // public eventsConfig = EVENTS_CONFIG;
  public eventsConfig;
  public driverListDataSource = new MatTableDataSource<any>([]);

  constructor(public dataService: DataService) {}

  public ngOnInit() {
    const combinedEventsList = this.dataService.modifyFleeEvents();
    const modifiedEventsConfig = this.dataService.transformObject(combinedEventsList);
    this.eventsConfig = { ...EVENTS_CONFIG, ...modifiedEventsConfig };
    if (this.loader) {
      this.driverListDataSource.data = new Array(5).fill(undefined);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    switch (this.listType) {
      case 'top-drivers':
        this.tableColumns = TOP_DRIVERS_TABLE_COLUMNS;
        break;
      case 'require-coaching':
        this.tableColumns = REQUIRE_COACHING_TABLE_COLUMNS;
        break;
      case 'most-improved':
        this.tableColumns = MOST_IMPROVED_TABLE_COLUMNS;
        break;
      default:
        this.tableColumns = TOP_DRIVERS_TABLE_COLUMNS;
    }

    this.driverListDataSource.data = this.loader ? new Array(5).fill(undefined) : [];

    if (changes.driverList && changes.driverList.currentValue) {
      let filteredDriverList = [];
      if (this.listType === 'require-coaching') {
        filteredDriverList = this.driverList.slice(0, 5);
      } else {
        filteredDriverList = this.driverList.slice(0, 5).filter((x: any) => x.driverId !== '_UNASSIGNED');
      }
      this.driverListDataSource.data = filteredDriverList;
    }
  }
}
